/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Box, Card, Grid, LinearProgress } from '@mui/material';
import { CardList, DialogForm, ICardActions, ICardColumns, IChipFilter, IChipsSettingProps, IDialogActions, IKanbanCardColumns, ISnackbarAlert, ISwitchInputProps, KanbanList, SelectField, SnackbarAlert, TextFieldInput, ToolBar } from '../../../shared/components';
import { GenericService } from '../../../shared/services';
import { ListId, LocalStorange } from '../../../shared/environment';
import { useTheme } from '@mui/material/styles';
import { AccessRoleDTO, AccessRoleFilterDTO, InterviewDTO, InterviewFilterDTO, PeopleDTO, PeopleFilterDTO, ResumeDTO, ValueListDTO } from '../../../shared/interfaces';
import { LayoutDashboard } from '../../../shared/layouts';
import { InterviewMaintenance } from './InterviewMaintenance';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { useTranslation } from 'react-i18next';

interface IInterviewProps {
    vacancyId: any;
    resumeId: any;
    setIsOpenMaintenance: (value: boolean) => void;
    isOpenMaintenance: boolean;
    setActionExecuted: (value: boolean) => void;
    actionExecuted: boolean | false;
}

export const Interview: React.FC<IInterviewProps> = ({ vacancyId, resumeId, isOpenMaintenance, setIsOpenMaintenance, setActionExecuted, actionExecuted }) => {
    const [interviewList, setInterviewList] = useState<InterviewDTO[]>([]);
    const [interviewFilterDTO, setInterviewFilterDTO] = useState<InterviewFilterDTO>();
    const [InterviewerList, setInterviewerList] = useState<PeopleDTO[]>([]);
    const [typeList, setTypeList] = useState<ValueListDTO[]>([]);
    const [statusList, setStatusList] = useState<ValueListDTO[]>([]);
    const [resumeList, setResumeList] = useState<any[]>([]);

    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenMessage, setIsOpenSnackBar] = useState(false);
    const [isOpenMaintenanceLocal, setIsOpenMaintenanceLocal] = useState(false);

    const [accessRolePermissionDTO, setAccessRolePermissionDTO] = useState<AccessRoleDTO>();
    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');
    const theme = useTheme();
    const { t } = useTranslation();

    useEffect(() => {
        setInterviewFilterDTO({
            ...interviewFilterDTO,
            vacancyId: vacancyId,
            resumeId: resumeId ?? '',
            typeId: '',
            statusId: '',
            interviewedById: ''
        } as InterviewFilterDTO);

        handleListGetAll(ListId.talentsphere.interview.typeId, setTypeList);
        handleListGetAll(ListId.talentsphere.interview.statusId, setStatusList);
        handleResumeGetAllViewAsync();
        handleInterviewerGetAllAsync();
        handleGetPermission(ListId.talentsphere.interviewId, setAccessRolePermissionDTO);
    }, [vacancyId]);

    useEffect(() => {
        handleInterviewGetAllViewAsync();
    }, [interviewFilterDTO]);

    useEffect(() => {
        if (actionExecuted) {
            handleInterviewGetAllViewAsync();
        }
    }, [actionExecuted]);

    useEffect(() => {
        setEditRecord('');
    }, [isOpenMaintenance]);

    const handleGetPermission = useCallback(async (featureId: string, setList: any) => {
        const accessRoleFilterDTO: AccessRoleFilterDTO = {
            featureId: featureId,
            userId: userInfo.user.id,
        };
        GenericService.PostGenericAsync1('authsphere.AccessRole', 'GetPermissionAsync', accessRoleFilterDTO, setActionExecuted, setLoading, undefined, setList,);
    }, []);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'valueindex, value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleResumeGetAllViewAsync = useCallback(async () => {
        const filterDTO = {
            resumeId: resumeId ?? '',
            vacancyId: vacancyId,
            statusId: '',
            createdById: '',
            searchAssociated: true
        };

        GenericService.GetAllViewAsync1('talentsphere.ResumeVacancy', filterDTO, setActionExecuted, setLoading, setResumeList, showMessage, true);
    }, []);

    const handleInterviewerGetAllAsync = useCallback(async () => {
        const peopleFilterDTO: PeopleFilterDTO = {

        };
        GenericService.GetAllAsync1('corpsphere.people', peopleFilterDTO, setLoading, setInterviewerList, showMessage);
    }, []);

    const handleInterviewGetAllViewAsync = useCallback(async () => {
        if (interviewFilterDTO === undefined)
            return;
        if(accessRolePermissionDTO?.allowGetAllView == undefined)
            return;
        if(!accessRolePermissionDTO?.allowGetAllView) {
            showMessage(t('message.allowGetAllView'), 'info');
            return;
        }
        GenericService.GetAllViewAsync1('talentsphere.Interview', interviewFilterDTO, setActionExecuted, setLoading, setInterviewList, showMessage, true);
    }, [interviewFilterDTO, accessRolePermissionDTO]);

    const handleClearFilterSelectedClick = () => {
        setInterviewFilterDTO({
            ...interviewFilterDTO,
            vacancyId: vacancyId,
            resumeId: resumeId ?? '',
            typeId: '',
            interviewedById: '',
            statusId: ''
        } as InterviewFilterDTO);
    };

    const handleSearchSelectedClick = () => {
        handleInterviewGetAllViewAsync();
    };

    const handleNew = () => {
        if (!accessRolePermissionDTO?.allowAdd) {
            showMessage(t('message.allowGetAllView'), 'info');
            return;
        }
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleViewDetatils = (data: string) => {
        if (!accessRolePermissionDTO?.allowGetById) {
            showMessage(t('message.allowGetById'), 'info');
            return;
        }
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setIsOpenMaintenanceLocal(true);
    };

    const handleDelete = (data: string) => {
        if (!accessRolePermissionDTO?.allowDelete) {
            showMessage(t('message.allowDelete'), 'info');
            return;
        }
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord(data);
        setIsOpenMaintenanceLocal(true);
    };

    const actions: IDialogActions[] = [
        { id: 'close', text: t('interview.dialogActions.close'), icon: 'close_outlined', iconColor: 'secondary', setAction: () => void undefined },
    ];

    const cardActionsSelected: ICardActions[] = [
        { id: 'viewDetails', toolTip: t('interview.cardActionsSelected.viewDetails'), icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: t('interview.cardActionsSelected.delete'), icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
    ];

    const chipFiltersSelected: IChipFilter[] = [
        { label: t('interview.chipFiltersSelected.totalRecords'), value: interviewList.length },
        { label: 'Type', value: typeList.find(x => x.id === interviewFilterDTO?.typeId)?.value },
        { label: t('interview.chipFiltersSelected.interviewer'), value: InterviewerList.find(x => x.id === interviewFilterDTO?.interviewedById)?.fullName },
        { label: t('interview.chipFiltersSelected.resume'), value: resumeList.find(x => x.resumeId === interviewFilterDTO?.resumeId)?.name },
        { label: t('interview.chipFiltersSelected.status'), value: statusList.find(x => x.id === interviewFilterDTO?.statusId)?.value },
    ];

    const toolBarActionsSelected: IDialogActions[] = [
        { id: 'new', text: t('interview.toolBarActionsSelected.newInterview'), icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const chipStatus : IChipsSettingProps[] = [
        { value: t('interview.chipsSettingProps.approved'), iconName: 'task_alt_outlined', iconColor: 'success' },
        { value: t('interview.chipsSettingProps.disapproved'), iconName: 'block_outlined', iconColor: 'error' },
    ];

    const chipType : IChipsSettingProps[] = [
        { value: t('interview.chipsSettingProps.humanResources'), iconName: 'support_agent_outlined', iconColor: 'primary' },
        { value: t('interview.chipsSettingProps.technicalSpecialist'), iconName: 'manage_accounts_outlined', iconColor: 'secondary' },
        { value: t('interview.chipsSettingProps.costumer'), iconName: 'people_outlined', iconColor: 'warning' },
    ];

    const columns: ICardColumns[] = [
        { field: 'type', label: t('interview.cardColumns.type'), size: 2, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true, noWrap: false, chipSettings: chipType },
        { field: 'interviewer', label: t('interview.cardColumns.interviewer'), size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true, noWrap: false },
        { field: 'code', label: t('interview.cardColumns.code'), size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true, noWrap: false },
        { field: 'resume', label: t('interview.cardColumns.resume'), size: 3, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true, noWrap: false },
        { field: 'status', label: t('interview.cardColumns.status'), size: 1, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true, noWrap: false, chipSettings: chipStatus },
        { field: 'creationDateTime', label: t('interview.cardColumns.creationDate'), size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
    ];
    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenMessage && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenMessage}
                />
            )}
            <DialogForm
                title={t('interview.dialogForm.title')}
                icon='interview_outlined'
                setIsOpen={setIsOpenMaintenance}
                isOpen={isOpenMaintenance}
                fullWidth={true}
                maxWidth={'xl'}
                actions={actions}
                loading={false}
            >
                <LayoutDashboard title={t('interview.layoutDashboard.title')}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12}>
                            <Card sx={{ bgcolor: theme.palette.background.default, p: 1, height: '65vh' }}>
                                <ToolBar
                                    clickSearch={handleSearchSelectedClick}
                                    clickClearFilter={handleClearFilterSelectedClick}
                                    chipFilters={chipFiltersSelected}
                                    actions={toolBarActionsSelected}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} md={3}>
                                            <SelectField
                                                id='typeId'
                                                label={t('interview.selectField.type')}
                                                setValue={setInterviewFilterDTO}
                                                value={interviewFilterDTO?.typeId}
                                                obj={interviewFilterDTO}
                                                valueList={typeList}
                                                hasNoneSelect={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <SelectField
                                                id='interviewedById'
                                                label={t('interview.selectField.interview')}
                                                setValue={setInterviewFilterDTO}
                                                value={interviewFilterDTO?.interviewedById}
                                                obj={interviewFilterDTO}
                                                valueList={InterviewerList}
                                                hasNoneSelect={true}
                                                labelKey='fullName'
                                                valueKey='id'
                                                searchable={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <SelectField
                                                id='resumeId'
                                                label={t('interview.selectField.resume')}
                                                setValue={setInterviewFilterDTO}
                                                value={interviewFilterDTO?.resumeId}
                                                obj={interviewFilterDTO}
                                                valueList={resumeList}
                                                hasNoneSelect={true}
                                                labelKey='name'
                                                valueKey='resumeId'
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <SelectField
                                                id='statusId'
                                                label={t('interview.selectField.status')}
                                                setValue={setInterviewFilterDTO}
                                                value={interviewFilterDTO?.statusId}
                                                obj={interviewFilterDTO}
                                                valueList={statusList}
                                                hasNoneSelect={true}
                                            />
                                        </Grid>
                                    </Grid>
                                </ToolBar>
                                {loading && (
                                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                                )}
                                <Box sx={{ display: 'flex', maxHeight: '56vh', width: '100%', overflow: 'hidden', overflowY: 'auto' }}>
                                    <CardList
                                        columns={columns}
                                        rows={interviewList}
                                        actions={cardActionsSelected}
                                        hasChildren={false}
                                        setRowExpanded={() => void undefined}
                                        cardSize={12}
                                    />
                                </Box>
                            </Card>
                        </Grid>
                    </Grid>
                </LayoutDashboard>
            </DialogForm >
            {newRecord && (
                <InterviewMaintenance
                    vacancyId={vacancyId}
                    data={''}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                />
            )}
            {editRecord && (
                <InterviewMaintenance
                    vacancyId={vacancyId}
                    data={editRecord}
                    setIsOpenMaintenance={setIsOpenMaintenanceLocal}
                    isOpenMaintenance={isOpenMaintenanceLocal}
                    setActionExecuted={setActionExecuted}
                />
            )}
            {deleteRecord && (<Delete
                entity={'talentsphere.interview'}
                data={deleteRecord}
                setIsOpenDiaglog={setIsOpenMaintenanceLocal}
                isOpenDialog={isOpenMaintenanceLocal}
                setActionExecuted={setActionExecuted}
                indexAttributeLabel={5}
            />)}
        </React.Fragment >
    );
};
